<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header py-0">
          <a-row class='py-2'>
            <a-col :sm='24' :lg='15' class='pr-1'>
              <a-input style="width: 100%" placeholder="Buscar..." v-model:value="searchText"
                @keyup.enter="getBusinessUnits(10, 0, searchText)" />
            </a-col>
            <a-col :sm='12' :lg='4' class='pl-1'>
              <button style="width: 100%" class="btn bg-holcim-bright-green text-white"
                @click="getBusinessUnits(10, 0, searchText)">
                <i class="fe fe-refresh-cw" />
                Buscar
              </button>
            </a-col>
            <a-col :sm='12' :lg='4' class='pl-1'>
              <button class="btn bg-holcim-dark-blue text-white" @click='openModal' style="width: 100%">
                <i class="fe fe-plus" />
                Nuevo
              </button>
            </a-col>
            <a-col :sm='12' :lg='1' class='pl-1'>
              <router-link to="/catalogos/principal" style="width: 100%" class="btn bg-holcim-bright-blue">
                <i class="fe fe-arrow-left" />
              </router-link>
            </a-col>
          </a-row>
        </div>

        <a-modal :closable="false" :visible="visible" title="Registro de Unidad de Negocio">
          <a-form :model="form" ref="ruleForm" :rules="rules" @finish="submit" layout="vertical" label-align="left">
            <a-form-item required label="Código de Unidad de Negocio:" name="code">
              <a-input v-model:value="form.code" placeholder="Código de Unidad de Negocio" />
            </a-form-item>

            <a-form-item required label="Nombre de Unidad de Negocio:" name="name">
              <a-input v-model:value="form.name" placeholder="Nombre de Unidad de Negocio" />
            </a-form-item>

            <error-manager-component v-if="errorHandler.errorDescription.errors.length > 0"
              :errors="errorHandler.errorDescription.errors" />

            <a-row class='py-1'>
              <a-col span="8" offset="10" v-if="formLoad">
                <a-spin tip="Cargando..." />
              </a-col>
              <a-col span="12" class="pt-1 pl-1" offset="6" v-else>
                <button type="submit" style="width: 100%" class="btn bg-holcim-bright-green text-white">
                  <i class="fe fe-save" />
                  Guardar
                </button>
              </a-col>
            </a-row>

          </a-form>

          <template #footer>
            <a-button key="back" @click="closeModal">
              <i class='fe fe-x-circle pr-2' />
              Cerrar
            </a-button>
          </template>
        </a-modal>

        <div class="card-body">
          <business-unit-table :data="businessUnits" :loading="tableLoading" @openModal="eventOpenModal"
            @openPlantsModal="eventOpenPlantsModal" @softDelete="eventSoftDelete" />
          <a-pagination class="pt-4" v-model="paginatorCurrentPage" :total="paginatorTotalItems"
            @change="onChangePaginator" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import BusinessUnitTable from './components/BusinessUnitTable'
import useBusinessUnit from '../../../composables/useBusinessUnit'
import ErrorManagerComponent from '../../../components/errorManagerComponent'

export default {
  name: 'BusinessUnitsindex',
  components: { ErrorManagerComponent, BusinessUnitTable },
  setup() {
    const {
      searchText,
      visible,
      visiblePlants,
      formId,
      form,
      formLoad,
      rules,
      businessUnits,
      plants,
      tableLoading,
      plantsLoading,
      errorHandler,
      ruleForm,

      paginatorTotalItems,
      paginatorTotalPages,
      paginatorCurrentPage,
      onChangePaginator,

      openPlantsModal,
      closePlantsModal,
      openModal,
      closeModal,
      getBusinessUnits,
      submit,
      deleteRecord,

      eventOpenModal,
      eventOpenPlantsModal,
      eventSoftDelete,
    } = useBusinessUnit()

    return {
      searchText,
      visible,
      visiblePlants,
      formId,
      form,
      formLoad,
      rules,
      businessUnits,
      plants,
      tableLoading,
      plantsLoading,
      errorHandler,
      ruleForm,

      paginatorTotalItems,
      paginatorTotalPages,
      paginatorCurrentPage,
      onChangePaginator,

      openPlantsModal,
      closePlantsModal,
      openModal,
      closeModal,
      getBusinessUnits,
      submit,
      deleteRecord,

      eventOpenModal,
      eventOpenPlantsModal,
      eventSoftDelete,
    }
  },
}
</script>

<style scoped></style>
